// Auth route — Sign-up (US-001 + US-202).

import { createRoute } from '@tanstack/react-router';

import { SignUpPage } from '@/features/auth/SignUpPage';

import { Route as RootRoute } from '../__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/auth/signup',
  component: SignUpPage,
});
